"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.ai.title': 'Zapytaj Asystenta AI',
    'socialMediaPlan.ai.desc': 'Asystent analizuje bibliotekę postów i doradza kolejne kroki.',
    'socialMediaPlan.ai.preset.topics': 'Jakie tematy przyniosą najlepsze zaangażowanie?',
    'socialMediaPlan.ai.preset.plan': 'Zaproponuj plan treści na przyszły tydzień',
    'socialMediaPlan.ai.preset.timing': 'Kiedy najlepiej publikować?',
    'socialMediaPlan.ai.preset.summary': 'Podsumowanie wyników miesiąca',
    'socialMediaPlan.ai.ask': 'Zapytaj AI',
    'socialMediaPlan.ai.error': 'Błąd asystenta AI. Spróbuj ponownie.',
};
